import { z } from 'zod';

import { HttpClient } from '../clients/http/HttpClient';
import { publicAPIClient } from '../clients/shippo/PublicAPIClient';
import { DataEntitlements } from '../hooks/useDataEntitlements';

const DATA_ENTITLEMENTS_SCHEMA = z.object({
  intelligent_analytics: z.boolean(),
});

type DataEntitlementsResponse = z.infer<typeof DATA_ENTITLEMENTS_SCHEMA>;

class DataEntitlementService {
  private parseEntitlements = (response: DataEntitlementsResponse): DataEntitlements => ({
    hasIntelligenceAccess: response.intelligent_analytics,
  });

  get = async (routeToIntelligenceEnabled: boolean): Promise<DataEntitlements> => {
    const url = routeToIntelligenceEnabled
      ? '/intelligence/data_entitlements'
      : '/simulation/data_entitlements';

    const { body } = await this.httpClient.get<DataEntitlementsResponse>({
      timeout: 5000, // 5 seconds
      url,
    });

    const response = DATA_ENTITLEMENTS_SCHEMA.parse(body);

    return this.parseEntitlements(response);
  };

  constructor(private readonly httpClient: HttpClient = publicAPIClient) {}
}

export const dataEntitlementService = new DataEntitlementService();
